import { createSlice } from '@reduxjs/toolkit'

import { PersonaInquiryStatusEnum } from '../Persona/Persona.types'

import type { Account, TSocialMediaUser } from './Users.types'

export interface userSliceState {
  userId: string
  firstname: string
  lastname: string
  email: string
  account: Account
  phoneNumber: string
  role: string
  permissions: string[]
  status: string
  from: string
  pdfLanguage: string
  credits: number
  impersonationCredits: number
  profileImgUrl: string
  language: string
  socialMedias: TSocialMediaUser[]
}

export const userInfoSliceInitialState: userSliceState = {
  userId: '',
  firstname: '',
  lastname: '',
  email: '',
  account: {
    id: '',
    credits: 0,
    statusKYC: PersonaInquiryStatusEnum.EMPTY,
    KYCInquiryId: '',
    plan: null,
    isEarlyAdopter: false,
  },
  phoneNumber: '',
  role: '',
  permissions: [],
  status: '',
  from: '',
  pdfLanguage: 'en',
  credits: 0,
  impersonationCredits: 0,
  profileImgUrl: '',
  language: 'en',
  socialMedias: [],
}

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: userInfoSliceInitialState,
  reducers: {
    setUserInfo: (state, action) => {
      const userInfo = action.payload
      state.userId = userInfo.id
      state.firstname = userInfo.firstname
      state.lastname = userInfo.lastname
      state.email = userInfo.email
      state.account = userInfo.account
      state.phoneNumber = userInfo.phoneNumber
      state.role = userInfo.role
      state.permissions = userInfo.permissions
      state.status = userInfo.status
      state.pdfLanguage = userInfo.pdfLanguage
      state.credits = userInfo.account.credits
      state.impersonationCredits = userInfo.account.impersonationCredits || 0
      state.profileImgUrl = userInfo.profilePicUrl
      state.language = userInfo.language
      state.socialMedias = userInfo.socialMedias || []
    },
    setUserOrigin: (state, action) => {
      state.from = action.payload
    },
    updateProfileImage: (state, action) => {
      state.profileImgUrl = action.payload
    },
    updateUserPdfLanguage: (state, action) => {
      state.pdfLanguage = action.payload.pdfLanguage
    },
    updateConfirmInformation: (state, action) => {
      state.firstname = action.payload.firstname
      state.lastname = action.payload.lastname
      state.email = action.payload.email
    },
    updateSocialMedia: (state, action) => {
      state.socialMedias = action.payload
    },
    updateUserName: (state, action) => {
      state.firstname = action.payload.firstname
      state.lastname = action.payload.lastname
    },
  },
})
export const {
  setUserInfo,
  setUserOrigin,
  updateProfileImage,
  updateUserPdfLanguage,
  updateConfirmInformation,
  updateSocialMedia,
  updateUserName,
} = userInfoSlice.actions

export default userInfoSlice.reducer
